<template>
    <div class="container-center">
<!--        0_合同、1_通知、2_维修、3_其他）-->
        <el-tabs v-model="activeName" type="card" class="tabs" @tab-click="tabClicked">
            <el-tab-pane label="全部" name="-1">
<!--                <msg-list ref="msg1" :type-name="activeName"  v-show="activeName == -1"/>-->
            </el-tab-pane>
            <el-tab-pane name="0">
                <div slot="label">
                    <div style="position:relative">
                        合同
                        <span v-if="count0 > 0" style="width:10px;height:10px;background:red;position: absolute;border-radius: 50%;
    top: 7px"></span>
                    </div>
                </div>
<!--                <msg-list ref="msg2" :type-name="activeName" v-show="activeName == 0"/>-->
            </el-tab-pane>
            <el-tab-pane name="1">
                <div slot="label">
                    <div style="position:relative">
                        通知
                        <span v-if="count1 > 0" style="width:10px;height:10px;background:red;position: absolute;border-radius: 50%;
    top: 7px"></span>
                    </div>
                </div>
<!--                <msg-list ref="msg3" :type-name="activeName" v-show="activeName == 1"/>-->
            </el-tab-pane>
            <el-tab-pane name="2">
                <div slot="label">
                    <div style="position:relative">
                        维修
                        <span v-if="count2 > 0" style="width:10px;height:10px;background:red;position: absolute;border-radius: 50%;
    top: 7px"></span>
                    </div>
                </div>
<!--                <msg-list ref="msg4" :type-name="activeName" v-show="activeName == 2"/>-->
            </el-tab-pane>
            <el-tab-pane name="3">
                <div slot="label">
                    <div style="position:relative">
                        其他
                        <span v-if="count3 > 0" style="width:10px;height:10px;background:red;position: absolute;border-radius: 50%;
    top: 7px"></span>
                    </div>
                </div>
<!--                <msg-list ref="msg5" :type-name="activeName" v-show="activeName == 3"/>-->
            </el-tab-pane>
        </el-tabs>
        <msg-list ref="msgList" :type-name="activeName"/>
    </div>
</template>

<script>
import msgList from './comps/newMsgexList';
export default {
    name: 'newMessageTabs',
    components: { msgList },
    data () {
        return {
            activeName: '-1',
            messageCount:0,
            count0:0,
            count1:0,
            count2:0,
            count3:0,
        }
    },
    mounted () {
        this.getMessageReadInfo();
    },
    methods: {
        /*信息互通未读数量*/
        getMessageReadInfo(){
            this.$http.post('/rest/api/msg/getMessageCount', {stockId:this.$root.stockId}
            ).then((res)=>{
                if(res.data.result) {
                    if (res.data.value && res.data.value.length > 0) {
                        res.data.value.forEach(obj=>{
                            this.messageCount += obj.num;
                            if (obj.messageType == '0') {
                                this.count0 = obj.num;
                            }
                            if (obj.messageType == '1') {
                                this.count1 = obj.num;
                            }
                            if (obj.messageType == '2') {
                                this.count2 = obj.num;
                            }
                            if (obj.messageType == '3') {
                                this.count3 = obj.num;
                            }
                        })
                    }
                    //this.stockHomeInfo = res.data.value || {};
                }
            } , err => {
                this.$alert(err)
            })
        },
        tabClicked () {
            this.$refs.msgList.refresh(this.activeName);
        }
    }
}
</script>


<style lang="postcss" scoped>
.tabs{
    margin-top:25px;
}
</style>




// WEBPACK FOOTER //
// src/pages/dsp/msgex/newMessageTabs.vue